import { render, staticRenderFns } from "./relatedApprovalInput.vue?vue&type=template&id=3b6522bc&scoped=true&"
import script from "./relatedApprovalInput.vue?vue&type=script&lang=ts&"
export * from "./relatedApprovalInput.vue?vue&type=script&lang=ts&"
import style0 from "./relatedApprovalInput.vue?vue&type=style&index=0&id=3b6522bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6522bc",
  null
  
)

export default component.exports